import React, { useState } from "react";
import {
  // AiOutlineFacebook,
  AiOutlineInstagram,
  AiOutlineLinkedin,
} from "react-icons/ai";
import "../styles/style.css";

import { FaAngleDoubleRight, FaAngleDoubleLeft } from "react-icons/fa";

export default function SocialMedia() {
  const [isOpen, setOpen] = useState(true);
  return (
    <div
      id="socialmedia"
      className="h-screen flex items-center w-min fixed right-0 top-0"
    >
      <div
        className={`${
          isOpen ? "open" : "close"
        } transition duration-150 ease-in-out`}
      >
        {isOpen ? (
          <FaAngleDoubleRight
            onClick={() => setOpen(!isOpen)}
            className="text-6xl cursor-pointer text-black dark:text-white dark:hover:text-pink-700"
          />
        ) : (
          <FaAngleDoubleLeft
            onClick={() => setOpen(!isOpen)}
            className="text-6xl cursor-pointer text-black dark:text-white dark:hover:text-pink-700"
          />
        )}
      </div>
      <div
        className={`social-media-side-bar flex flex-col justify-around items-center px-1 w-18 h-60 transition duration-150 ease-in-out ${
          isOpen ? "open" : "close"
        }`}
      >
        {/* <a href="#" style={{height:"auto"}}>
          <AiOutlineFacebook className="social-media-logo text-black text-6xl transform dark:text-white dark:hover:text-pink-700" />
        </a> */}
        <a
          href="https://instagram.com/dsc_aissmscoe"
          target="_blank"
          rel="noopener noreferrer"
          style={{ height: "auto" }}
        >
          <AiOutlineInstagram className="social-media-logo text-black text-6xl transform dark:text-white dark:hover:text-pink-700" />
        </a>
        <a
          href="https://www.linkedin.com/company/dsc-aissmscoe-pune/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ height: "auto" }}
        >
          <AiOutlineLinkedin className="social-media-logo text-black text-6xl transform dark:text-white dark:hover:text-pink-700" />
        </a>
      </div>
    </div>
  );
}
